/* eslint-disable no-undef */
import VueRouter from 'vue-router';
import EduKarierMobileApp from './EduKarierMobileApp.vue';
import routes from './config/routes';
import stores from './store';
import api from './api';
import {BlFlexItemAv, BlFlexContainerMv, BlTextAv} from '@bukalapak/bazaar-mweb-latest';
import {createTracker} from 'shared_js/trackers';
import BrazeTracker from 'shared_js/helpers/braze';
import Sentry from 'lib/sentry';
import trackerMixin from './mixins/tracker';

import './styles/tailwind.css';
import '@bukalapak/bazaar-mweb-latest/dist/bazaar.css';
import 'vue-tour/dist/vue-tour.css';
import {publicUrl} from 'src/shared/javascripts/url-helpers';
import VueTour from 'vue-tour';

const boot = () => {
  Vue.prototype.$publicUrl = publicUrl;
  Vue.prototype.$tracker = createTracker();

  Vue.use(VueRouter);
  Vue.use(Vuex);
  Vue.use(VueTour);
  Vue.use(Sentry);

  Vue.component('BlFlexItemAv', BlFlexItemAv);
  Vue.component('BlFlexContainerMv', BlFlexContainerMv);
  Vue.component('BlTextAv', BlTextAv);

  Vue.prototype.$api = api;
  Vue.prototype.$logger = Sentry;

  const router = new VueRouter({
    base: '/edukarier',
    mode: 'history',
    routes,
  });
  const store = new Vuex.Store(stores);
  store.$api = api;

  return {
    app: new Vue({
      components: {EduKarierMobileApp},
      mixins: [trackerMixin],
      created() {
        if (!this.$tracker) {
          Vue.prototype.$tracker = createTracker();
        }

        this.initTracker();
        BrazeTracker.initialize();
      },
      template: `<EduKarierMobileApp />`,
      router,
      store,
    }),
    store,
  };
};

(() => {
  const {app, store} = boot();

  const dataFromServer = window.INIT_DATA;
  store.commit('setDataServer', dataFromServer);

  app.$mount('#edukarier-mobile-app');
})();
